import { memo as Memo, useEffect, useRef, useState } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

//* Components
import TableItem from '@components/global/TableItem';

const WhyChoose = Memo(({ title, items }) => {
	//! Refs
	const sectionRef = useRef();
	const triggerRef = useRef();

	//! States
	const [active, setActive] = useState(false);

	useEffect(() => {
		triggerRef.current = ScrollTrigger.create({
			start: 'top bottom',
			end: 'top bottom',
			trigger: sectionRef.current,
			// markers: true,
			onEnter: () => {
				setActive(true);
			},
			onLeaveBack: () => {
				setActive(false);
			},
		});

		return () => {
			if (triggerRef.current) {
				triggerRef.current.kill();
			}
		};
	});
	return (
		<div
			ref={sectionRef}
			className='why-choose-item'>
			<TableItem
				title={title}
				active={active}
				details={items}
				numberIndex={1}
			/>
		</div>
	);
});

export default WhyChoose;
